import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Paper } from "@mui/material";
import { getTranslations } from "../../utils/CardTranslations";

const CountingDay = ({ data, images = [] }) => {
  const hasImages = images.length > 0;
  const calculateTimeLeft = () => {
    const diff = +new Date(data.eventDate) - +new Date();

    let time = { days: 0, hours: 0, minutes: 0, seconds: 0 };

    if (diff > 0) {
      time = {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / 1000 / 60) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      };
    }
    return time;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const t = getTranslations(data.language);
  const items = [
    { label: t.days, value: timeLeft.days },
    { label: t.hours, value: timeLeft.hours },
    { label: t.minutes, value: timeLeft.minutes },
    { label: t.seconds, value: timeLeft.seconds },
  ];

  return (
    <Box textAlign="center" pt={3} pb={hasImages ? 2 : 3} sx={{ background: "transparent" }}>
      <Typography
        sx={{ color: data.themeColour, fontSize: "15px", fontWeight: "bold" }}
      >
        {t.countdownTitle}
      </Typography>

      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        mt={1}
      >
        {items.map((item) => (
          <Grid item key={item.label}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                borderRadius: 3,
                background: data.countDayColour,
                backdropFilter: "blur(6px)",
              }}
            >
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, color: data.themeColour, fontFamily: "Great Vibes", fontSize: "42px" }}
              >
                {item.value}
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{ mt: 1, color: data.labelCountDayColour }}
              >
                {item.label}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CountingDay;
